const Wallet = () => {
  return (
    <svg
      className='list-options__svg'
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.20508 3.5C0.652794 3.5 0.205078 3.94775 0.205078 4.5V15.5C0.205078 16.0522 0.652794 16.5 1.20508 16.5H15.2051C15.7574 16.5 16.2051 16.0522 16.2051 15.5V13.5H13.2051C12.6528 13.5 12.2051 13.0522 12.2051 12.5V10.5C12.2051 9.94775 12.6528 9.5 13.2051 9.5H16.2051V6.5C16.2051 5.94775 15.7574 5.5 15.2051 5.5H1.70508C1.42894 5.5 1.20508 5.27637 1.20508 5C1.20508 4.72363 1.42893 4.5 1.70508 4.5H12.7051C12.9812 4.5 13.2051 4.27637 13.2051 4C13.2051 3.72363 12.9812 3.5 12.7051 3.5H1.20508Z'
        fill='white'
      />
      <path d='M16.2051 10.5H13.2051V12.5H16.2051V10.5Z' fill='white' />
    </svg>
  );
};
export default Wallet;
